import react, { useReducer, useMemo, useContext } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { Box, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material'
import Table from '../../Table'
import { DatePicker } from '@mui/x-date-pickers'
import { number2dayweek } from '../../Utils/dayjsptbrhelper'
import dayjs from 'dayjs'
import { customTheme } from '../../theme/textfieldTheme';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import ColorButton from '../../Buttons/ColorButton'
import { externalComponent } from '../../AppRoutes'
import { api } from '../../../services/api'

export const incentivos = {
    'naoinformado': 'Não informado',
    'prodep': 'Prodep',
    'incentivo_portuario': 'Sem incentivo',
    'semincentivo': 'Sem incentivo',
    'Todos': 'Todos'
}

const icmsitem = {
    'todos': 'Todos',
    'comicms': 'Com ICMS',
    'semicms': 'Sem ICMS'
}

const saldoitem = {
    'todos': 'Todos',
    'comsaldo': 'Com Saldo',
    'semsaldo': 'Sem Saldo'
}

const getcolumns = () => {
    const columns = []
    columns.push({field: 'tipo_incentivo', headerName: 'Tipo Incentivo'})
    columns.push({field: 'filial', headerName: 'Filial', width: 5})
    columns.push({field: 'numNF', headerName: 'Núm. NF'})
    columns.push({field: 'serie', headerName: 'Sér', width: 5})
    columns.push({field: 'dtchegada', headerName: 'Dt. Chegada'})
    columns.push({field: 'fornecedor', headerName: 'Fornecedor', flex: 1})
    columns.push({field: 'codigo', headerName: 'Código'})
    columns.push({field: 'produto', headerName: 'Produto', flex: 1})
    columns.push({field: 'qtdeentr', headerName: 'Qtde Entr'})
    columns.push({field: 'uniticms', headerName: 'Unit. B. Icms'})
    columns.push({field: 'totalicms', headerName: 'Total Base Icms'})
    columns.push({field: 'qtdesaida', headerName: 'Qtde Saída'})
    columns.push({field: 'saldo', headerName: 'Saldo Atual'})
    return columns
}

const initial_state = {
    dataini: '',
    dataend: '',
    numeronf: '',
    tipoincentivo: '',
    codpro: '',
    baseicmsitem: 'todos',
    saldoitem: 'todos',
}

const requestData = async (state, setState, setLoader) => {

    const res = await api.get(`/nfse/`, {params: {
        'test': 1
    }})
}

const NFSEntrada = () => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        ...initial_state,
        edit: null,
        rows: []
    })

    const outerTheme = useTheme();

    return (
        <>
            <Box className='nfsentrada-mainframe'>
                <ThemeProvider theme={customTheme(outerTheme)}>
                    <Box sx={{ flex: .15 }} className='nfsentrada-filters'>
                        <Box className='filter-items'>
                            <FormControl sx={{ width: '13rem' }} size="small">
                                <InputLabel id="demo-simple-select-label">Tipo Incentivo</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Tipo Incentivo"
                                    value={state.tipoincentivo}
                                    onChange={(e) => setState({ tipoincentivo: e.target.value })}
                                >
                                    {
                                        Object.entries(incentivos).map(([key, value]) => (
                                            <MenuItem key={key} value={key}>{value}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                            <TextField
                                size='small'
                                value={state.numeronf}
                                onChange={({ target }) => setState({ numeronf: target.value })}
                                label='Número NF'
                            />
                            <DatePicker
                                slotProps={{ textField: { size: 'small' } }}
                                label="Dt. Cheg. Inicial"
                                size="small"
                                value={dayjs(state.dataini)}
                                onChange={(e) => setState({ dataini: e.format('YYYY-MM-DD') })}
                                format='DD/MM/YYYY'
                                dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                sx={{ width: '11rem' }}
                            />
                            <DatePicker
                                slotProps={{ textField: { size: 'small' } }}
                                label="Dt. Cheg. Final"
                                size="small"
                                value={dayjs(state.dataend)}
                                onChange={(e) => setState({ dataend: e.format('YYYY-MM-DD') })}
                                format='DD/MM/YYYY'
                                dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                sx={{ width: '11rem' }}
                            />
                            <TextField
                                size='small'
                                value={state.codpro}
                                onChange={({ target }) => setState({ codpro: target.value })}
                                label='Cod. Produto'
                            />
                            <FormControl sx={{ width: '10rem' }} size="small">
                                <InputLabel id="demo-base-icms-item">Base Icms Item</InputLabel>
                                <Select
                                    labelId="demo-base-icms-item"
                                    id="base-icms-item"
                                    label="Base Icms Item"
                                    value={state.baseicmsitem}
                                    onChange={(e) => setState({ baseicmsitem: e.target.value })}
                                >
                                    {
                                        Object.entries(icmsitem).map(([key, value]) => (
                                            <MenuItem key={key} value={key}>{value}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                            <FormControl sx={{ width: '10rem' }} size="small">
                                <InputLabel id="demo-saldo-item">Saldo Item</InputLabel>
                                <Select
                                    labelId="demo-saldo-item"
                                    id="saldo-item"
                                    label="Saldo Item"
                                    value={state.saldoitem}
                                    onChange={(e) => setState({ saldoitem: e.target.value })}
                                >
                                    {
                                        Object.entries(saldoitem).map(([key, value]) => (
                                            <MenuItem key={key} value={key}>{value}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Box>
                        <Box className='filter-buttons'>
                            <ColorButton onClick={()=> requestData(state, setState, setLoader)}>
                            Localizar
                            </ColorButton>
                            <ColorButton onClick={()=> setState(initial_state)}>
                            Limpar filtros
                            </ColorButton>
                        </Box>
                    </Box>
                </ThemeProvider>
                <Box sx={{ flex: .85, overflow:'hidden' }}>
                    <Table
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={useMemo(()=> getcolumns(setState), [state.rows, state.edit])}
                        pagination={false}
                        toolbar
                        slots={{
                            filterComponent: true,
                            columnComponent: true
                        }}
                        density='compact'
                        rowHeight={30}
                    />
                </Box>
            </Box>
        </>
    )

}

export default NFSEntrada